<div class="modal-header">
    <h3 class="modal-title text-modal-header-bold" id="modal-basic-title"> Búsqueda de interlocutor {{cabeceraTexto}}
        {{tipotitulobusqueda}}
    </h3>
    <button type="button" class="close" aria-label="Close" (click)="cancelar()" tabindex="401">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <!-- <div class="row">
        <div class="col-md-12">
            <button type="button" class="btn btn-rounded btn-warning" tabindex="402" (keydown.tab)="onNexFocus()"
                (click)="cancelar()"><i class="fa fa-times-circle"></i> Cancelar
            </button>
        </div>
    </div> -->
    <input type="text" placeholder="Buscar interlocutor ..." class="form-control col-md-6"
        (keydown)="onChange($event.target.value)" [(ngModel)]="csearchTerm" name="csearchTerm">

    <br>

    <div class="table-responsive" style="height: 70vh;">
        <table class="table table-sm table-striped table-bordered table-hover">
            <thead>
                <tr>
                    <th style="text-align: left;"> Código </th>
                    <th style="text-align: left;"> Razón social</th>

                    <th style="text-align: left;"> Nombres </th>

                    <th style="text-align: left;"> Documento </th>
                    <th style="text-align: center;"> Activo </th>
                </tr>
            </thead>
            <tbody>
                <tr class="cursor" [ngClass]="{'color-row': position == i}"
                    [ngClass]="{'nombre-de-la-clase': lst == this.lsttemp}"
                    *ngFor="let lst of interlocutores; index as i" (click)="onClick(lst)">
                    <td class="sorting" style="text-align: left; white-space: nowrap">
                        <ngb-highlight [result]="lst.codcli " [term]="csearchTerm"></ngb-highlight>
                    </td>
                    <td style="text-align: left;"> {{ lst.razonc }} </td>
                    <td style="text-align: left;"> {{ lst.nombresCompletos }} </td>
                    <!--<td> 
                        <ngb-highlight [result]="cabeceraTipo == '0' ? lst.nombresCompletos : lst.razonc " [term]="csearchTerm"></ngb-highlight>
                   
                    </td>-->
                    <!--<td *ngIf="cabeceraTipo=='1'" style="text-align: left;"> {{ lst.razonc  }} </td>-->
                    <!--<td *ngIf="this.cabeceraTipo=='0'" style="text-align: left;"> {{ lst.nombresCompletos }}  </td>
                    <td *ngIf="this.cabeceraTipo=='1'" style="text-align: left;"> {{ lst.razonc  }} </td>-->

                    <td *ngIf="lst.dident != ''" style="text-align: left;"> {{lst.tidentNombre}} - {{lst.dident }} </td>
                    <td *ngIf="lst.dident == ''" style="text-align: left;"> {{lst.tidentNombre}} </td>
                    <td>
                        <div style="text-align: center;" *ngIf="lst.clase_01 == '1' || lst.clase_01 == 'S'"> <i
                                class="fas fa-check fa-lg" style="color: green;"></i></div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>